import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { GetEnumValuesDto } from 'src/app/core/api/models';
import { EnumsService } from 'src/app/core/api/services';
import { EnumToTextConvertorPipe } from 'src/app/core/pipes/enum-text.pipe';
import { SavedEnumsService } from 'src/app/core/services/saved-enums.service';
import { AppPhoneBookSelectSearch } from 'src/app/core/types/app-phonebook-select-search.type';
import { PhonebooksService } from './../../../core/api/services/phonebooks.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'phonebook-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class PhoneBookSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  PhonebookTypesEnumValues: GetEnumValuesDto[] = [];

  @Input() type: AppPhoneBookSelectSearch = 'phonebooks';

  constructor(
    protected currentService: PhonebooksService,
    private enumService: EnumsService,
    private enumToTextConvertorPipe: EnumToTextConvertorPipe
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.getEnumValuesApi('PhonebookTypes')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.PhonebookTypesEnumValues = values));
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'optionTitle';
  }

  getItemsApi() {
    switch (this.type) {
      case 'phonebooks':
        {
          this.currentService
            .phonebooksGetPhonebooksWithPagination({
              body: { pageSize: 200, pageNumber: 1 },
            })
            .pipe(
              this.basePipeOperators(),
              map((items) => {
                return items.data.items.map((item) => {
                  const translatedPhoneBookType =
                    this.enumToTextConvertorPipe.transform(
                      item.phonebookTypes,
                      this.PhonebookTypesEnumValues
                    );
                  return {
                    ...item,
                    optionTitle: ` <span> ${item.name} (${item.contactsCount})
                  <b class='tw-px-1'> (${translatedPhoneBookType})</b>
                  </span>`,
                  };
                });
              })
            )
            .subscribe(this.baseObserver);
        }
        break;
      case 'phonebooksListForServices':
        {
          this.optionTitle = 'name';
          this.currentService
            .phonebooksGetPhonebooksListForServices()
            .pipe(this.basePipeOperators())
            .subscribe(this.baseObserver);
        }
        break;
      case 'currentOrganizationPhonebooks':
        this.currentService
          .phonebooksGetCurrentOrganizationPhonebooksList()
          .pipe(
            this.basePipeOperators(),
            map((items) => {
              return items.data.map((item) => {
                return {
                  ...item,
                  optionTitle: ` <span> ${item.name} </span>`,
                };
              });
            })
          )
          .subscribe((items) => {
            this.items = items;
          });

        break;
    }
  }

  getEnumValuesApi(enumName): Observable<GetEnumValuesDto[]> {
    if (SavedEnumsService.getEnum(enumName) != null)
      return SavedEnumsService.getEnumAsObservable(enumName);

    this.enumService
      .enumsGetEnumValues({ EnumTypeName: enumName })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((newEnum) => {
        SavedEnumsService.pushEnum({
          enumName: enumName,
          enumValue: newEnum.data,
        });
      });

    // save enum
    return this.enumService.enumsGetEnumValues({ EnumTypeName: enumName }).pipe(
      takeUntil(this.onDestroy$),
      map((res) => res.data)
    );
  }
}
